import { TagTextDocs } from './TagTextDocs';
import { TagButtonDocs } from './TagButtonDocs';
import { TagListDocs } from './TagList/TagListDocs';
import { Doc, Component, Story, Section } from './DocTypes';
import { TagNavDocs } from './TagNavDocs';
import { TagAccessLogoDocs } from './TagAccessLogoDocs';
import { TagAlertDocs } from './TagAlertDocs';
import { TagAppHeaderDocs } from './TagAppHeaderDocs';
import { TagAvatarDocs } from './TagAvatarDocs';
import { TagBadgeDocs } from './TagBadgeDocs';
import { TagBarDocs } from './TagBarDocs';
import { TagCardProfileDocs } from './TagCardProfileDocs';
import { TagCardDocs } from './TagCardDocs';
import { TagCheckboxDocs } from './TagCheckboxDocs';
import { TagColourDocs } from './TagColourDocs';
import { TagComboboxDocs } from './TagComboboxDocs';
import { TagConfirmDocs } from './TagConfirmDocs';
import { TagDatePickerDocs } from './TagDatePickerDocs';
import { TagEditFieldDocs } from './TagEditFieldDocs';
import { TagTabsDocs } from './TagTabsDocs';
import { TagTableDocs } from './TagTableDocs';
import { TagToolTipDocs } from './TagTooltipDocs';
import { TagFieldDocs } from './TagFieldDocs';
import { TagFilePickerDocs } from './TagFilePickerDocs';
import { TagLinkDocs } from './TagLinkDocs';
import { TagSearchboxDocs } from './TagSearchboxDocs';
import { TagStatDocs } from './TagStatDocs';
import { TagProgressIndeterminateDocs } from './TagProgressIndeterminateDocs';
import { TagProgressDonutDocs } from './TagProgressDonutDocs';
import { TagPillsDocs } from './TagPillsDocs';
import { TagPillDocs } from './TagPillDocs';
import { TagWizardDocs } from './TagWizardDocs';
import { TagSliderDocs } from './TagSliderDocs';
import { TagTopNavbarDocs } from './TagTopNavbarDocs';
import { TagGraphqlDocs } from './TagGraphqlDocs';
import { TagPagerDocs } from './TagPagerDocs';
import { TagMessageDocs } from './TagMessageDocs';
import { TagIconDocs } from './TagIconDocs';
import { TagToastDocs } from './TagToastDocs';
import { TagSearchDocs } from './TagSearchDocs';
import { TagToggleDocs } from './TagToggleDocs';
import { TagStatsDocs } from './TagStatsDocs';
import { TagPopoverDocs } from './TagPopoverDocs';
import { TagMenuDocs } from './TagMenuDocs';
import { TagNavSimpleDocs } from './TagNavSimpleDocs';
import { TagHttpDocs } from './TagHttpDocs';
import { TagValidationDocs } from './TagValidationDocs';
import { TagModalDocs } from './TagModalDocs';
import { TagTabHeadersDocs } from './TagTabHeadersDocs';
import { TagDataBinderDocs } from './TagDataBinderDocs';
import { TagFormDocs } from './TagFormDocs';
import { TagTextFeatureDocs } from './TagTextFeatureDocs';
import { TagFormatDocs } from './TagFormatDocs';
import { TagH1Docs } from './TagH1Docs';
import { TagH2Docs } from './TagH2Docs';
import { TagH3Docs } from './TagH3Docs';
import { TagH4Docs } from './TagH4Docs';
import { TagH5Docs } from './TagH5Docs';
import { TagKpiLabelDocs } from './TagKpiLabelDocs';
import { TagKpiDocs } from './TagKpiDocs';
import { TagLabelDocs } from './TagLabelDocs';
import { TagPDocs } from './TagPDocs';
import { TagTextSmallDocs } from './TagTextSmallDocs';
import { TagSpanDocs } from './TagSpanDocs';
import { TagSimpleButtonDocs } from './TagSimpleButtonDocs';
import { TagRoundButtonDocs } from './TagRoundButtonDocs';
import { TagSquareButtonDocs } from './TagSquareButtonDocs';
import { TagTertiaryButtonDocs } from './TagTertiaryButtonDocs';
import { TagInputDocs } from './TagInputDocs';
import { TagValidationAlertDocs } from './TagValidationAlertDocs';
import { TagValidatorDocs } from './TagValidatorDocs';
import { TagIconSvgDocs } from './TagIconSvgDocs';
import { TagMenuButtonDocs } from './TagMenuButtonDocs';
import { TagSegmentedMenuButtonDocs } from './TagSegmentedMenuButtonDocs';
import { TagMobileNavDocs } from './TagMobileNavDocs';
import { TagWizardVerticalDocs } from './TagVerticalWizardDocs';
import { TagValidationAlertInlineDocs } from './TagValidationAlertInlineDocs';
import { TagClickableDocs } from './TagClickableDocs';
import { TagSimpleModalDocs } from './TagSimpleModalDocs';
import { TagMobileModalDocs } from './TagMobileModalDocs';
import { TagMobileSideMenuDocs } from './TagMobileSideMenuDocs';
import { TagMobileSliderPopoverDocs } from './TagMobileSliderPopoverDocs';
import { TagMobileVerticalSliderPanelDocs } from './TagMobileVerticalSliderPanelDocs';
import { TagMobileSwipeoutDocs } from './TagMobileSwipeoutDocs';
import { TagSwitchDocs } from './TagSwitchDocs';
import { TagMobileFanMenuDocs } from './TagMobileFanMenuDocs';
import { TagColumnPickerDocs } from './TagColumnPickerDocs';
import { TagDropDownDocs } from './TagDropDownDocs';
import { TagRadioButtonsDocs } from './TagRadioButtonsDocs';
import { TagTextareaDocs } from './TagTextareaDocs';
import { TagCarouselDocs } from './TagCarouselDocs';
import { TagFilePickerButtonDocs } from './TagFilePickerButtonDocs';
import { TagFilePickerDragdropDocs } from './TagFilePickerDragdrop';
import { TagCustomColourPickerDocs } from './TagCustomColourPickerDocs';
import { TagAutocompleteDocs } from './TagAutocompleteDocs';
import { TagSimpleListDocs } from './TagSimpleListDocs';
import { TagChartDocs } from './TagChartDocs';
import { TagMobileDateTimeInputDocs } from './TagMobileDateTimeInputDocs';
import { TagMobileTimeInputDocs } from './TagMobileTimeInputDocs';
import { TagMobileDropDownDocs } from './TagMobileDropDownDocs';
import { TagMobileHeaderDocs } from './TagMobileHeaderDocs';
import { TagSideNavDocs } from './TagSideNavDocs';
import { TagMobileAlertDocs } from './TagMobileAlertDocs';
import { TagMobileToastDocs } from './TagMobileToastDocs';
import { TagMobileSideMenuListDocs } from './TagMobileSideMenuListDocs';
import { TagSkeletonDocs } from './TagSkeletonDocs';
// import { TagDropDownFlexDocs } from './TagDropDownFlexDocs';
import { TagLinkButtonDocs } from './TagLinkButtonDocs';

const docs: Doc[] = [
  { type: 'page', route: 'welcome', name: 'Welcome', icon: 'Home' },
  { type: 'page', route: 'icons', name: 'Icons', icon: 'Image' },
  { type: 'page', route: 'colours', name: 'Colours', icon: 'Paintbrush' },
  { type: 'page', route: 'play', name: 'Play', icon: 'Code' },
  {
    type: 'section',
    name: 'Form libraries',
    components: [
      { type: 'page', route: 'reacthookformsv6', name: 'React Hook Form v6', icon: 'Bug' },
      { type: 'page', route: 'formik', name: 'Formik', icon: 'Bug' },
    ],
  },
  {
    type: 'section',
    name: 'Data Output',
    components: [
      TagAvatarDocs,
      TagBadgeDocs,
      TagBarDocs,
      TagCarouselDocs,
      TagColumnPickerDocs,
      TagDataBinderDocs,
      TagFieldDocs,
      TagFormatDocs,
      TagIconDocs,
      TagIconSvgDocs,
      TagListDocs,
      TagPagerDocs,
      TagPillsDocs,
      TagPillDocs,
      TagProgressDonutDocs,
      TagSimpleListDocs,
      TagStatDocs,
      TagStatsDocs,
      TagTableDocs,
      TagChartDocs,
    ],
  },

  {
    type: 'section',
    name: 'Text',
    components: [
      TagH1Docs,
      TagH2Docs,
      TagH3Docs,
      TagH4Docs,
      TagH5Docs,
      TagKpiDocs,
      TagKpiLabelDocs,
      TagLabelDocs,
      TagPDocs,
      TagSpanDocs,
      TagTextFeatureDocs,
      TagTextSmallDocs,
      TagTextDocs,
    ],
  },
  {
    type: 'section',
    name: 'Inputs',
    components: [
      TagAutocompleteDocs,
      TagCheckboxDocs,
      TagColourDocs,
      TagComboboxDocs,
      TagCustomColourPickerDocs,
      TagDatePickerDocs,
      TagDropDownDocs,
      // TagDropDownFlexDocs,
      TagEditFieldDocs,
      TagFilePickerDocs,
      TagFilePickerButtonDocs,
      TagFilePickerDragdropDocs,
      TagFormDocs,
      TagInputDocs,
      TagRadioButtonsDocs,
      TagSliderDocs,
      TagTextareaDocs,
      TagToggleDocs,
      TagValidationDocs,
      TagValidationAlertDocs,
      TagValidationAlertInlineDocs,
      TagValidatorDocs,
      TagWizardDocs,
      TagWizardVerticalDocs,
      TagSwitchDocs,
    ],
  },
  {
    type: 'section',
    name: 'Actions',
    components: [
      TagButtonDocs,
      TagSimpleButtonDocs,
      TagSquareButtonDocs,
      TagRoundButtonDocs,
      TagTertiaryButtonDocs,
      TagLinkDocs,
      TagLinkButtonDocs,
      TagMenuDocs,
      TagMenuButtonDocs,
      TagSegmentedMenuButtonDocs,
      TagClickableDocs,
    ],
  },
  {
    type: 'section',
    name: 'Layout',
    components: [
      TagAppHeaderDocs,
      TagCardDocs,
      TagCardProfileDocs,
      TagMobileFanMenuDocs,
      TagMobileModalDocs,
      TagMobileNavDocs,
      TagMobileVerticalSliderPanelDocs,
      TagModalDocs,
      TagSideNavDocs,
      TagNavDocs,
      TagNavSimpleDocs,
      TagPopoverDocs,
      TagSimpleModalDocs,
      TagTabsDocs,
      TagTabHeadersDocs,
      TagToolTipDocs,
      TagTopNavbarDocs,
    ],
  },

  {
    type: 'section',
    name: 'Feedback',
    components: [TagAlertDocs, TagConfirmDocs, TagMessageDocs, TagToastDocs],
  },
  {
    type: 'section',
    name: 'Server communication',
    components: [
      TagGraphqlDocs,
      TagHttpDocs,
      TagProgressIndeterminateDocs,
      TagSearchDocs,
      TagSearchboxDocs,
    ],
  },
  {
    type: 'section',
    name: 'Utils',
    components: [TagAccessLogoDocs],
  },
  {
    type: 'section',
    name: 'Mobile',
    components: [
      TagMobileHeaderDocs,
      TagMobileAlertDocs,
      TagMobileToastDocs,
      TagMobileDateTimeInputDocs,
      TagMobileTimeInputDocs,
      TagMobileDropDownDocs,
      TagMobileSwipeoutDocs,
      TagMobileSliderPopoverDocs,
      TagMobileSideMenuDocs,
      TagMobileSideMenuListDocs,
      TagSkeletonDocs,
    ],
  },
];

export const COMPONENTS_PREFIX = 'tag-';

export const getAllDocs = () => docs;

export function getFilteredDocs(search: string) {
  let searchWithoutPrefix = COMPONENTS_PREFIX.includes(search.toLowerCase())
    ? ''
    : search.replace(COMPONENTS_PREFIX, '').toLowerCase();
  return searchWithoutPrefix.length === 0
    ? getAllDocs()
    : getAllDocs().filter(doc => {
        let shouldBeDisplayed = doc.name.toLowerCase().includes(searchWithoutPrefix);
        if (!shouldBeDisplayed && doc.type === 'section') {
          shouldBeDisplayed = doc.components.some(comp =>
            comp.name.toLowerCase().includes(searchWithoutPrefix),
          );
        }
        return shouldBeDisplayed;
      });
}

export function getFilteredComponents(doc: Section, search: string) {
  let searchWithoutPrefix = COMPONENTS_PREFIX.includes(search.toLowerCase())
    ? ''
    : search.replace(COMPONENTS_PREFIX, '').toLowerCase();
  return searchWithoutPrefix.length === 0
    ? doc.components
    : doc.components.filter(comp => comp.name.toLowerCase().includes(searchWithoutPrefix));
}

export const getAllComponents = () => docs.filter(doc => doc.type === 'component') as Component[];

export const getComponent = (componentName: string): Component | null => {
  const sections = docs.filter(doc => doc.type === 'section') as Section[];
  let found: Component | null = null;
  sections.forEach(section => {
    const foundInSection =
      section &&
      (section.components.find(
        doc => doc.type === 'component' && doc.name.toLowerCase() === componentName.toLowerCase(),
      ) as Component | undefined);
    if (foundInSection) {
      found = foundInSection;
    }
  });
  return found;
};

export const getSection = (sectionName: string): Section | null => {
  const found = docs.find(
    doc => doc.type === 'section' && doc.name.toLowerCase() === sectionName.toLowerCase(),
  );
  return found as Section;
};

export const getStory = (componentName: string, storyTitle: string): Story | null => {
  const component = getComponent(componentName);
  if (!component) {
    return null;
  }
  const found =
    component &&
    component.stories &&
    component.stories.find(story => story.title.toLowerCase() === storyTitle.toLowerCase());
  return found ? found : null;
};
